import {
  DsAccordionModule,
  DsBoxModule,
  DsButtonModule,
  DsCheckboxModule,
  DsColumnData,
  DsFormFieldModule,
  DsIconModule,
  DsLoadingAreaConfiguration,
  DsLoadingAreaService,
  DsModalModule,
  DsProgressCircleModule,
  DsRowData,
  DsSelectModule,
  DsTableModule,
  DsTabsModule,
  DsToastModel,
  DsToastService,
  SelectListOption,
} from '@bmw-ds/components';
import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { CrossBorderService } from '../../../services/crossborder.service';
import {
  JobMast,
  Options,
  OrdMast,
  PackOption,
  UnitUpdateRequest,
  UnitUpdateResponse,
  Z11UpdateUnitHeaderRequest,
} from '../../../models/unit-update-model';
import { FormsModule } from '@angular/forms';
import { NgForOf, NgIf } from '@angular/common';
import { ModelPricingModalComponent } from '../model-pricing/model-pricing-modal';
import { PricePerBodyRequest } from '../../../models/price-per-body.model';
import { PricePerBodyService } from '../../../services/price-per-body.service';
import {
  HistoryOption,
  UnitUpdateHistoryResponse,
} from '../../../models/unit-update-history.model';
import {
  CosyUrlResponse,
  Z11Fp3GetCosyUrlRequest,
} from '../../../models/cosy.model';
import { NatisDocsService } from '../../../services/natis.service';
import {
  IvsrHeader,
  OkaError,
  Z11CallIvsrRequest,
  Z11CallIvsrResponse,
} from '../../../models/ivst.model';
import { AuthService } from '../../../services/auth.service';
import { InvoiceRequest } from '../../../models/sms.model';
import { SmsService } from '../../../services/sms.service';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-unit-update-modal',
  templateUrl: './unit-update-modal.html',
  imports: [
    DsBoxModule,
    DsModalModule,
    DsAccordionModule,
    DsProgressCircleModule,
    DsTableModule,
    DsFormFieldModule,
    DsSelectModule,
    FormsModule,
    DsTabsModule,
    NgForOf,
    DsButtonModule,
    DsIconModule,
    NgIf,
    ModelPricingModalComponent,
    DsCheckboxModule,
  ],
  styleUrls: ['./unit-update-modal.scss'],
})
export class UnitUpdateModalComponent implements OnInit {
  unitUpdateModalIsOpen: boolean = false;
  // unitUpdateResponse: UnitUpdateResponse;

  unitUpdateResponse: UnitUpdateResponse = {
    errorMessage: '',
    errorIndicator: '',
    bodyno: '',
    brand: '',
    do_not_show_price: '',
    order: '',
    vin: '',
    engineNo: '',
    statusCode: '',
    statusdesc: '',
    deallocateDate: '',
    prodweek: '',
    modelCode: '',
    modeldesc: '',
    orderPriority: '',
    ordprioritydesc: '',
    may_not_update: '',
    priceDate: '',
    otp: '',
    sabiIndividualBlockDate: '',
    invoiceInd: '',
    invoicedesc: '',
    orderModificationUser: '',
    omusername: '',
    invoiceprint: '',
    mayinvoice: '',
    message: '',
    vehtype: '',
    specialDelivery: '',
    salesType: '',
    salestypedesc: '',
    errormessage: '',
    payment: '',
    paymentdesc: '',
    despatch: '',
    despatchdesc: '',
    dealerCode: '',
    dealername: '',
    template_id: '',
    idlr: [],
    job_mast: {} as JobMast,
    ord_mast: {} as OrdMast,
    isale: [],
    idesp: [],
    ipay: [],
    iopt: [],
    modelOptions: [],
    solidPaint: [],
    metallicPaint: [],
    clothInterior: [],
    leatherInterior: [],
    rim: [],
    packs: [],
    ipop: [],
  };

  iopt?: Options[]; // maps from "iopt"
  modelOptions?: Options[]; // maps from "iopt"
  solidPaint?: Options[]; // maps from "iopt"
  metallicPaint?: Options[]; // maps from "iopt"
  clothInterior?: Options[]; // maps from "iopt"
  leatherInterior?: Options[]; // maps from "iopt"
  rim?: Options[]; // maps from "iopt"
  packs?: PackOption[]; // maps from "iopt"
  // selectedSalesType: any;

  constructor(
    private crossBorderService: CrossBorderService,
    private smsService: SmsService,
    private natisDocsService: NatisDocsService,
    private pricePerBodyService: PricePerBodyService,
    private loadingAreaService: DsLoadingAreaService,
    private toastService: DsToastService,
    private readonly authService: AuthService,
    private readonly cdr: ChangeDetectorRef
  ) {}
  async ngOnInit(): Promise<void> {
    if (this.authService.isAuthenticated()) {
      this.loadingAreaConfig = {
        id: 'bodyLoading',
        loadingTitle: 'Loading...',
        loadingText: 'Please wait...',
      };
      this.loadingAreaService.addLoadingArea(this.loadingAreaConfig);
      const urlParams = new URLSearchParams(window.location.search);
      const vin = urlParams.get('vin') || '';
      const bodyNo = urlParams.get('bodyNo') || '';
      if (vin.length < 17) {
        await this.getUnitUpdateModalIsOpen('', bodyNo);
      } else {
        await this.getUnitUpdateModalIsOpen(vin, bodyNo);
      }
    } else {
      window.location.href = this.authService.getAuthUrl(); // Redirect to the auth URL
    }

    // this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
  }

  unitUpdateRequest: UnitUpdateRequest = {
    bodyorderno: '',
    vin: '',
    euserid: localStorage.getItem('euserid') || '',
    externalUrl: '',
  };
  pricePerBodyRequest: PricePerBodyRequest = {
    bodyno: '',
    vin: '',
  };
  invoiceRequest: InvoiceRequest = {
    vin: '',
    iv_body_no: '',
  };
  orderResultModalIsOpen: boolean = false;
  @ViewChild(ModelPricingModalComponent)
  modelPricingModal!: ModelPricingModalComponent;
  showTable: boolean = false;
  rowsData: DsRowData[] = [];
  OptionsRowsData: DsRowData[] = [];
  OptionsHistoryRowsData: DsRowData[] = [];
  optionHistoryFirstColumn: DsColumnData[] = [
    { field: 'date', headerName: 'Date' },
    { field: 'time', headerName: 'Time' },
    { field: 'id', headerName: 'ID' },
    { field: 'name', headerName: 'Name' },
  ];
  optionHistorySecondColumn: DsColumnData[] = [
    { field: 'category', headerName: 'Category' },
    { field: 'standard', headerName: 'Standard' },
    { field: 'pack', headerName: 'Pack' },
    { field: 'code', headerName: 'Code' },
    { field: 'description', headerName: 'Description' },
  ];
  columnData: DsColumnData[] = [
    { field: 'selected', headerName: 'Selected' },
    { field: 'code', headerName: 'Code' },
    { field: 'description', headerName: 'Description' },
    { field: 'retailPrice', headerName: 'Price' },
  ];
  exteriorColumnData: DsColumnData[] = [
    { field: 'selected', headerName: 'Selected' },
    { field: 'swatch', headerName: 'Swatch' },
    { field: 'code', headerName: 'Code' },
    { field: 'description', headerName: 'Description' },
    { field: 'retailPrice', headerName: 'Price' },
  ];
  optionsColumnData: DsColumnData[] = [
    { field: 'selected', headerName: 'Selected' },
    { field: 'code', headerName: 'Code' },
    { field: 'description', headerName: 'Description' },
    { field: 'retailPrice', headerName: 'Price' },
  ];
  overviewColumnData: DsColumnData[] = [
    { field: 'category', headerName: 'Category' },
    { field: 'code', headerName: 'Code' },
    { field: 'description', headerName: 'Description' },
    { field: 'pack', headerName: 'Pack' },
    { field: 'retailPrice', headerName: 'Price' },
  ];
  standardColumnData: DsColumnData[] = [
    { field: 'selected', headerName: 'Selected' },
    { field: 'code', headerName: 'Code' },
    { field: 'description', headerName: 'Description' },
  ];
  loadingAreaConfig: DsLoadingAreaConfiguration = {
    id: 'bodyLoading',
    loadingTitle: '',
    loadingText: '',
  };
  specialDeliveryOptions: { id: string; label: string }[] = [];
  SalesTypeOptions: { id: string; label: string }[] = [];
  DispatchCodesOption: { id: string; label: string }[] = [];
  unitUpdateHistoryResponse!: UnitUpdateHistoryResponse;
  // expandedRow: number | null = null;
  clickedVin: string = '';
  showOptionsHistory = false;


  getUnitUpdateModalIsOpen(vin: string | number, bodyNo: string) {
    this.loadingAreaConfig = {
      id: 'bodyLoading',
      loadingTitle: 'Updating Unit',
      loadingText: 'Please wait...',
    };
    this.loadingAreaService.addLoadingArea(this.loadingAreaConfig);
    this.unitUpdateModalIsOpen = true;
    this.unitUpdateRequest.vin = vin?.toString() || '';
    this.unitUpdateRequest.bodyorderno = bodyNo;
    this.crossBorderService.unitUpdate(this.unitUpdateRequest).subscribe(
      (response) => {
        if (response.errormessage) {
          this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
          this.addToast('critical', response.errormessage);
        } else {
          this.selectedSalesType = response.ord_mast?.zsale_typ ?? '';
          this.selectedSalesDispatch = response.ord_mast?.zdes_cde ?? '';
          this.selectedDespatchOption = response.ord_mast?.zdes_cde ?? '';
          this.zsdeliv = response.ord_mast?.zsdeliv ?? '';
          this.unitUpdateResponse = {
            job_mast: response.job_mast
              ? {
                  zbody: response.job_mast.zbody,
                  zeng: response.job_mast.zeng,
                  zmodel: response.job_mast.zmodel,
                  zorder: response.job_mast.zorder,
                  zvin: response.job_mast.zvin,
                  zlst_trck: response.job_mast.zlst_trck,
                  zgearbox: response.job_mast.zgearbox,
                  zois_deal: response.job_mast.zois_deal,
                  zinfo1: response.job_mast.zinfo1,
                  zoka: response.job_mast.zoka,
                  zradio: response.job_mast.zradio,
                  zrcde: response.job_mast.zrcde,
                  zohf_deal: response.job_mast.zohf_deal,
                }
              : undefined,
            ord_mast: response.ord_mast
              ? {
                  zord_pri: response.ord_mast.zord_pri,
                  zprod_pri: response.ord_mast.zprod_pri,
                  stat_code: response.ord_mast.stat_code,
                  zbody: response.ord_mast.zbody,
                  zstock_ind: response.ord_mast.zstock_ind,
                  zcl_cde: response.ord_mast.zcl_cde,
                  zcons_dte: response.ord_mast.zcons_dte,
                  zcons_ind: response.ord_mast.zcons_ind,
                  zdeall_dte: response.ord_mast.zdeall_dte,
                  zdes_cde: response.ord_mast.zdes_cde,
                  dist_code: response.ord_mast.dist_code,
                  zeng: response.ord_mast.zeng,
                  zf2_dte: response.ord_mast.zf2_dte,
                  zfirm_cust_ind: response.ord_mast.zfirm_cust_ind,
                  zfirm_dte: response.ord_mast.zfirm_dte,
                  fl_avgkm: response.ord_mast.fl_avgkm,
                  fl_confirm: response.ord_mast.fl_confirm,
                  fl_costmandte: response.ord_mast.fl_costmandte,
                  fl_costman: response.ord_mast.fl_costman,
                  fl_cur_body: response.ord_mast.fl_cur_body,
                  comp_id: response.ord_mast.comp_id,
                  fl_carno: response.ord_mast.fl_carno,
                  fl_currkm: response.ord_mast.fl_currkm,
                  fl_okaerr: response.ord_mast.fl_okaerr,
                  fl_order: response.ord_mast.fl_order,
                  fl_reject: response.ord_mast.fl_reject,
                  rejreason: response.ord_mast.rejreason,
                  fl_req_dte: response.ord_mast.fl_req_dte,
                  fleet_reserve: response.ord_mast.fleet_reserve,
                  fleet_scheme: response.ord_mast.fleet_scheme,
                  fl_towbar_req: response.ord_mast.fl_towbar_req,
                  fl_vehschm: response.ord_mast.fl_vehschm,
                  zgearbox: response.ord_mast.zgearbox,
                  harb_code: response.ord_mast.harb_code,
                  zois_deal: response.ord_mast.zois_deal,
                  zind: response.ord_mast.zind,
                  zinv_ind: response.ord_mast.zinv_ind,
                  zinv_dte: response.ord_mast.zinv_dte,
                  zinvoice: response.ord_mast.zinvoice,
                  zdlr: response.ord_mast.zdlr,
                  zoerrflag: response.ord_mast.zoerrflag,
                  rtrqprdwk: response.ord_mast.rtrqprdwk,
                  zohf_deal: response.ord_mast.zohf_deal,
                  zlst_trck: response.ord_mast.zlst_trck,
                  zload: response.ord_mast.zload,
                  zmodel: response.ord_mast.zmodel,
                  nca_ind: response.ord_mast.nca_ind,
                  nca_process_dte: response.ord_mast.nca_process_dte,
                  zorder: response.ord_mast.zorder,
                  zodlr: response.ord_mast.zodlr,
                  zret_dte: response.ord_mast.zret_dte,
                  zotp: response.ord_mast.zotp,
                  pay_code: response.ord_mast.pay_code,
                  zplant_code: response.ord_mast.zplant_code,
                  zprice_dte: response.ord_mast.zprice_dte,
                  zpri_change: response.ord_mast.zpri_change,
                  zproc_cde: response.ord_mast.zproc_cde,
                  zprodw: response.ord_mast.zprodw,
                  zreq_dte: response.ord_mast.zreq_dte,
                  zreq_prodw: response.ord_mast.zreq_prodw,
                  zret_ind: response.ord_mast.zret_ind,
                  i_block_dte: response.ord_mast.i_block_dte,
                  zm_hold: response.ord_mast.zm_hold,
                  zsale_typ: response.ord_mast.zsale_typ,
                  ship_code: response.ord_mast.ship_code,
                  zsdeliv: response.ord_mast.zsdeliv,
                  zstd: response.ord_mast.zstd,
                  order_temp_broken: response.ord_mast.order_temp_broken,
                  template_id: response.ord_mast.template_id,
                  mstmp: response.ord_mast.mstmp,
                  uname: response.ord_mast.uname,
                  zvin: response.ord_mast.zvin,
                }
              : undefined,
            bodyno: response.bodyno,
            vin: response.job_mast?.zvin,
            brand: response.brand,
            modeldesc: response.modeldesc,
            ordprioritydesc: response.ordprioritydesc,
            vehtype: response.vehtype,
            salestypedesc: response.salestypedesc,
            paymentdesc: response.paymentdesc,
            despatchdesc: response.despatchdesc,
            dealername: response.dealername,
            message: response.message,
            idlr: response.idlr?.map((dealer) => ({
              kunnr: dealer.kunnr,
              name1: dealer.name1,
              region: dealer.region,
              active: dealer.active,
            })),
            isale: response.isale?.map((sale) => ({
              zsale_typ: sale.zsale_typ,
              description: sale.description,
            })),
            idesp: response.idesp?.map((dispatch) => ({
              zdes_cde: dispatch.zdes_cde,
              zdes_desc: dispatch.zdes_desc,
              fromdate: dispatch.fromdate,
              todate: dispatch.todate,
              dealer_ind: dispatch.dealer_ind,
              last_chande_by: dispatch.last_chande_by,
              last_change_dat: dispatch.last_change_dat,
            })),
            ipay: response.ipay?.map((payment) => ({
              pay_code: payment.pay_code,
              pay_desc: payment.pay_desc,
            })),
            iopt: response.iopt?.map((option) => ({
              zoption: option.zoption,
              pack_flag: option.pack_flag,
              o_desc: option.o_desc,
              zpack_cde: option.zpack_cde,
              std_ind: option.std_ind,
              on_unit: option.on_unit,
              zindind: option.zindind,
              zprice: option.zprice,
              zopt_ind: option.zopt_ind,
              feat_grp: option.feat_grp,
              opt_typ: option.opt_typ,
            })),
            solidPaint: response.solidPaint,
            metallicPaint: response.metallicPaint,
            clothInterior: response.clothInterior,
            leatherInterior: response.leatherInterior,
            modelOptions: response.modelOptions,
            rim: response.rim,
            packs: response.packs,
            ipop: response.ipop,
          };
          this.SalesTypeOptions =
            this.unitUpdateResponse.isale?.map((sale) => ({
              id: sale.zsale_typ ? sale.zsale_typ : '',
              label: sale.zsale_typ + ' - ' + sale.description,
            })) || [];
          this.specialDeliveryOptions =
            this.unitUpdateResponse.idlr?.map((dispatch) => ({
              id: dispatch.kunnr ? dispatch.kunnr : '',
              label: dispatch.kunnr + ' - ' + dispatch.name1,
            })) || [];
          this.DispatchCodesOption =
            this.unitUpdateResponse.idesp?.map((dispatch) => ({
              id: dispatch.zdes_cde ? dispatch.zdes_cde : '',
              label: dispatch.zdes_cde + ' - ' + dispatch.zdes_desc,
            })) || [];

          this.unitUpdateResponse.mayinvoice = response.mayinvoice;
          this.unitUpdateResponse.may_not_update = response.may_not_update;
          this.unitUpdateResponse.invoiceprint = response.invoiceprint;
          this.unitUpdateResponse.invoiceprint = response.invoiceprint;
          this.unitUpdateResponse.ipop = response.ipop;

          this.onPackageTabClick();
          this.cdr.detectChanges();
          this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
        }
      },
      (error) => {
        console.error('Error updating unit:', error);
        this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
      }
    );
  }

  getSelectedDeliveryOption(
    $event: SelectListOption | SelectListOption[] | null
  ) {
    this.thereIsUpdateChange = true;
    const selectedValue = ($event as SelectListOption).id;

    this.zsdeliv = selectedValue;
    this.cdr.detectChanges();
  }

  //last fix working on select
  getSelectedSalesTypeOption(
    $event: SelectListOption | SelectListOption[] | null
  ) {
    this.thereIsUpdateChange = true;
    const selectedValue = ($event as SelectListOption).id;

    this.selectedSalesType = selectedValue;
    this.cdr.detectChanges();
  }

  closeModal() {}

  async onSearchVehicle(vin: string) {
    if (vin.length < 17) {
      await this.getUnitUpdateModalIsOpen('', vin);
    } else {
      await this.getUnitUpdateModalIsOpen(vin, '');
    }
  }

  onPackageTabClick() {
    this.loadingAreaConfig.loadingText = 'Loading Packages';
    this.loadingAreaService.addLoadingArea(this.loadingAreaConfig);
    this.OptionsRowsData = (this.unitUpdateResponse?.packs ?? []).map(
      (pack) => ({
        selected: pack.selected || '',
        code: pack.code || '',
        description: pack.description || '',
        retailPrice: pack.retailPrice
          ? parseFloat(pack.retailPrice).toFixed(2)
          : '0.00',
      })
    );
    this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
    // this.cdr.detectChanges();
    this.showTable = true;
  }

  onExteriorTabClick() {
    this.OptionsRowsData = (this.unitUpdateResponse?.solidPaint ?? []).map(
      (pack) => ({
        selected: pack?.on_unit || '',
        swatch: pack.swatchUrl || '',
        code: pack.zoption || '',
        description: pack.o_desc || '',
        retailPrice: pack.zprice ? parseFloat(pack.zprice).toFixed(2) : '0.00',
      })
    );
    this.OptionsRowsData.push(
      ...(this.unitUpdateResponse?.metallicPaint ?? []).map((pack) => ({
        selected: pack?.on_unit || '',
        swatch: pack.swatchUrl || '',
        code: pack.zoption || '',
        description: pack.o_desc || '',
        retailPrice: pack.zprice ? parseFloat(pack.zprice).toFixed(2) : '0.00',
      }))
    );
  }

  onInteriorTabClick() {
    this.OptionsRowsData = (this.unitUpdateResponse?.clothInterior ?? []).map(
      (pack) => ({
        selected: pack?.on_unit || '',
        code: pack.zoption || '',
        swatch: pack.swatchUrl || '',
        description: pack.o_desc || '',
        retailPrice: pack.zprice ? parseFloat(pack.zprice).toFixed(2) : '0.00',
      })
    );
    this.OptionsRowsData.push(
      ...(this.unitUpdateResponse?.leatherInterior ?? []).map((pack) => ({
        selected: pack?.on_unit || '',
        code: pack.zoption || '',
        swatch: pack.swatchUrl || '',
        description: pack.o_desc || '',
        retailPrice: pack.zprice ? parseFloat(pack.zprice).toFixed(2) : '0.00',
      }))
    );
  }

  onRimsTabClick() {
    this.OptionsRowsData = (this.unitUpdateResponse?.rim ?? []).map((pack) => ({
      selected: pack?.on_unit || '',
      code: pack.zoption || '',
      swatch: pack.swatchUrl || '',
      description: pack.o_desc || '',
      retailPrice: pack.zprice ? parseFloat(pack.zprice).toFixed(2) : '0.00',
    }));
  }

  onOptionsTabClick() {
    this.OptionsRowsData = (this.unitUpdateResponse?.modelOptions ?? []).map(
      (pack) => ({
        selected: pack.on_unit || '',
        code: pack.zoption || '',
        description: pack.o_desc || '',
        retailPrice: pack.zprice ? parseFloat(pack.zprice).toFixed(2) : '0.00',
      })
    );
  }

  onOverviewTabClick() {
    this.OptionsRowsData = (this.unitUpdateResponse?.packs ?? [])
      .filter((pack) => pack.selected === 'X')
      .map((pack) => ({
        category: pack.category || '',
        code: pack.code || '',
        description: pack.description || '',
        pack: pack.pack || '',
        retailPrice: pack.retailPrice
          ? parseFloat(pack.retailPrice).toFixed(2)
          : '0.00',
      }));
    this.OptionsRowsData.push(
      ...(this.unitUpdateResponse?.solidPaint ?? [])
        .filter((pack) => pack.on_unit === 'X')
        .map((pack) => ({
          category: pack.category || '',
          code: pack.zoption || '',
          description: pack.o_desc || '',
          pack: pack.zpack_cde || '',
          retailPrice: pack.zprice
            ? parseFloat(pack.zprice).toFixed(2)
            : '0.00',
        }))
    );
    this.OptionsRowsData.push(
      ...(this.unitUpdateResponse?.metallicPaint ?? [])
        .filter((pack) => pack.on_unit === 'X')
        .map((pack) => ({
          category: pack.category || '',
          code: pack.zoption || '',
          description: pack.o_desc || '',
          pack: pack.zpack_cde || '',
          retailPrice: pack.zprice
            ? parseFloat(pack.zprice).toFixed(2)
            : '0.00',
        }))
    );
    this.OptionsRowsData.push(
      ...(this.unitUpdateResponse?.clothInterior ?? [])
        .filter((pack) => pack.on_unit === 'X')
        .map((pack) => ({
          category: pack.category || '',
          code: pack.zoption || '',
          description: pack.o_desc || '',
          pack: pack.zpack_cde || '',
          retailPrice: pack.zprice
            ? parseFloat(pack.zprice).toFixed(2)
            : '0.00',
        }))
    );
    this.OptionsRowsData.push(
      ...(this.unitUpdateResponse?.leatherInterior ?? [])
        .filter((pack) => pack.on_unit === 'X')
        .map((pack) => ({
          category: pack.category || '',
          code: pack.zoption || '',
          description: pack.o_desc || '',
          pack: pack.zpack_cde || '',
          retailPrice: pack.zprice
            ? parseFloat(pack.zprice).toFixed(2)
            : '0.00',
        }))
    );
    this.OptionsRowsData.push(
      ...(this.unitUpdateResponse?.rim ?? [])
        .filter((pack) => pack.on_unit === 'X')
        .map((pack) => ({
          category: pack.category || '',
          code: pack.zoption || '',
          description: pack.o_desc || '',
          pack: pack.zpack_cde || '',
          retailPrice: pack.zprice
            ? parseFloat(pack.zprice).toFixed(2)
            : '0.00',
        }))
    );
    this.OptionsRowsData.push(
      ...(this.unitUpdateResponse?.modelOptions ?? [])
        .filter((pack) => pack.on_unit === 'X')
        .map((pack) => ({
          category: pack.category || '',
          code: pack.zoption || '',
          description: pack.o_desc || '',
          pack: pack.zpack_cde || '',
          retailPrice: pack.zprice
            ? parseFloat(pack.zprice).toFixed(2)
            : '0.00',
        }))
    );
  }

  onStandardTabClick() {
    this.OptionsRowsData = (this.unitUpdateResponse?.iopt ?? [])
      .filter((pack) => pack.std_ind === 'X')
      .map((pack) => ({
        selected: pack.on_unit || '',
        code: pack.zoption || '',
        description: pack.o_desc || '',
      }));
  }

  onPricingClick() {
    this.loadingAreaConfig = {
      id: 'bodyLoading',
      loadingTitle: 'Loading',
      loadingText: 'Loading BMW Pricing',
    };
    this.loadingAreaService.addLoadingArea(this.loadingAreaConfig);
    this.pricePerBodyRequest = {
      bodyno: this.unitUpdateResponse?.bodyno || '',
      vin: this.unitUpdateResponse?.vin || '',
    };
    this.pricePerBodyService
      .getPricePerBody(this.pricePerBodyRequest)
      .subscribe(
        (response) => {
          this.modelPricingModal.pricePerBodyResponse = response;
          this.modelPricingModal.processPricePerBodyResponse(response);
          this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
          this.modelPricingModal.modelPricingModalIsOpen = true;
        },
        (error) => {
          this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
          console.error('Error fetching price per body:', error);
          this.toastService.pushToast(error);
        }
      );
  }

  openUnitOverviewModal() {
    const vin = this.unitUpdateResponse?.ord_mast?.zvin || '';
    window.open(environment.externalLinks.unitOverview + `${vin}`, '_blank');
  }

  openOptionHistoryModal() {
    this.loadingAreaConfig = {
      id: 'bodyLoading',
      loadingTitle: 'Loading',
      loadingText: 'Loading Option History',
    };
    this.loadingAreaService.addLoadingArea(this.loadingAreaConfig);
    this.unitUpdateRequest.vin = this.unitUpdateResponse?.ord_mast?.zvin || '';
    this.unitUpdateRequest.bodyorderno = this.unitUpdateResponse?.bodyno || '';
    this.crossBorderService.unitUpdateHistory(this.unitUpdateRequest).subscribe(
      (response) => {
        this.unitUpdateHistoryResponse = response;
        this.OptionsHistoryRowsData =
          this.unitUpdateHistoryResponse?.idate?.map((history) => ({
            date: history.zdate || '',
            time: history.ztime || '',
            id: history.zname || '',
            name: history.uname || '',
          })) || [];
        this.showOptionsHistory = true;
        this.cdr.detectChanges();
        this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
      },
      (error) => {
        console.error('Error fetching unit update history:', error);
        this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
      }
    );
  }

  toggleRowExpansion(rowIndex: number) {
    this.expandedRow = this.expandedRow === rowIndex ? null : rowIndex;
  }

  expandedRow: number | null = null;
  nestedRowsData: any[] = [];
  i: number = 0;

  onRowClick(rowIndex: number, rowData: any) {
    this.i = rowIndex;
    this.expandedRow = this.expandedRow === rowIndex ? null : rowIndex;
    // Example: Load nested data for the clicked rowd
    this.nestedRowsData[rowIndex] = this.getNestedTableData(rowData);
  }

  getNestedTableData(rowData: { time: string }): HistoryOption[] {
    const history = this.unitUpdateHistoryResponse?.idate?.find(
      (h) => h.ztime === rowData.time
    );
    return (
      history?.zoptions?.map((option: HistoryOption) => ({
        zopt_ind: option.zopt_ind,
        category: option.category,
        zopt_code: option.zopt_code,
        zopt_desc: option.zopt_desc,
        zpack_ind: option.zpack_ind,
        zpack_cde: option.zpack_cde,
        zstd: option.zstd,
      })) || []
    );
  }
  showDespatchSelect(): boolean {
    return (
      this.unitUpdateResponse?.idesp?.length > 0 &&
      this.unitUpdateResponse?.mayinvoice === 'X'
    );
  }

  cozyRequest: Z11Fp3GetCosyUrlRequest = {
    VIN: '',
    body_no: '',
    exterior: '',
    interior: '',
    limited_wa: '',
    model: '',
    prod_date: '',
    quality: '',
    quickview: '',
    transparent: '',
    width: '',
    optionss: [],
    options: '',
  };
  onPreviewClick() {
    //add loaders
    this.loadingAreaConfig.id = 'cozyLoading';
    this.loadingAreaConfig.loadingTitle = 'Loading..';
    this.cozyRequest.prod_date = this.unitUpdateResponse?.ord_mast?.zprodw;
    this.cozyRequest.model = this.unitUpdateResponse?.ord_mast?.zmodel;
    this.cozyRequest.width = '750';
    this.cozyRequest.transparent = 'TRANSPARENT';
    this.cozyRequest.quality = '90';
    this.cozyRequest.exterior =
      (this.unitUpdateResponse.solidPaint ?? [])
        .filter((paint) => paint.on_unit === 'X')
        .map((paint) => paint.zoption)
        .join('') ||
      (this.unitUpdateResponse.metallicPaint ?? [])
        .filter((paint) => paint.on_unit === 'X')
        .map((paint) => paint.zoption)
        .join('');
    this.cozyRequest.interior =
      (this.unitUpdateResponse.clothInterior ?? [])
        .filter((interior) => interior.on_unit === 'X')
        .map((interior) => interior.zoption)
        .join('') ||
      (this.unitUpdateResponse.leatherInterior ?? [])
        .filter((interior) => interior.on_unit === 'X')
        .map((interior) => interior.zoption)
        .join('');

    this.cozyRequest.optionss = (this.unitUpdateResponse?.packs ?? [])
      .filter((pack) => pack.selected === 'X')
      .map((pack) => pack.code);

    this.cozyRequest.optionss.push(
      ...(this.unitUpdateResponse?.solidPaint ?? []).map((pack) => pack.zoption)
    );
    this.cozyRequest.optionss.push(
      ...(this.unitUpdateResponse?.metallicPaint ?? [])
        .filter((pack) => pack.on_unit === 'X')
        .map((pack) => pack.zoption)
    );
    this.cozyRequest.optionss.push(
      ...(this.unitUpdateResponse?.clothInterior ?? [])
        .filter((pack) => pack.on_unit === 'X')
        .map((pack) => pack.zoption)
    );
    this.cozyRequest.optionss.push(
      ...(this.unitUpdateResponse?.leatherInterior ?? [])
        .filter((pack) => pack.on_unit === 'X')
        .map((pack) => pack.zoption)
    );
    this.cozyRequest.optionss.push(
      ...(this.unitUpdateResponse?.rim ?? [])
        .filter((pack) => pack.on_unit === 'X')
        .map((pack) => pack.zoption)
    );
    this.cozyRequest.optionss.push(
      ...(this.unitUpdateResponse?.modelOptions ?? [])
        .filter((pack) => pack.on_unit === 'X')
        .map((pack) => pack.zoption)
    );
    this.cozyRequest.optionss.push(
      ...(this.unitUpdateResponse?.iopt ?? [])
        .filter((pack) => pack.std_ind === 'X')
        .map((pack) => pack.zoption)
    );

    this.cozyRequest.options = this.cozyRequest.optionss
      .map((optionCode: string) => optionCode.trim().toUpperCase())
      .join('');
    this.natisDocsService.getCosyUrl(this.cozyRequest).subscribe((response) => {
      this.cosyViewsTree = response;
      this.previewOrderModalIsOpen = true;
      this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);

    },
      (error) => {
      this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
      console.error('Error fetching cosy url:', error);
      });
  }

  async onSaveClick() {
    if (this.thereIsUpdateChange) {
      await this.doInvoice();
    } else {
      await this.SaveOrder();
    }
    // this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
  }

  onPrintClick() {}

  protected readonly console = console;
  selectedExterior: any;
  previewOrderModalIsOpen: boolean = false;
  cosyViewsTree: CosyUrlResponse = {
    exturl: '',
    exturl_string: '',
    inturl: '',
    inturl_string: '',
    viewtypestr: undefined,
    messages: [],
    options: [],
    viewtypes: [],
    wa_360: [],
    EXCEPTION: [],
  };

  onExteriorSelectionChange(rowElement: string | number, $event: Event) {
    this.thereIsOptionsUpdateChange = true;
    // Deselect all solidPaint and metallicPaint options
    if (this.unitUpdateResponse.solidPaint) {
      this.unitUpdateResponse.solidPaint.forEach((exterior) => {
        exterior.on_unit = '';
      });
    }
    if (this.unitUpdateResponse.metallicPaint) {
      this.unitUpdateResponse.metallicPaint.forEach((exterior) => {
        exterior.on_unit = '';
      });
    }

    // Find and select the clicked option
    const selected = ($event.target as HTMLInputElement).checked;
    const exteriorIndex = this.unitUpdateResponse.solidPaint?.findIndex(
      (exterior) => exterior.zoption === rowElement
    );
    if (exteriorIndex !== undefined && exteriorIndex !== -1) {
      this.unitUpdateResponse.solidPaint![exteriorIndex].on_unit = selected
        ? 'X'
        : '';
    } else {
      const metallicIndex = this.unitUpdateResponse.metallicPaint?.findIndex(
        (exterior) => exterior.zoption === rowElement
      );
      if (metallicIndex !== undefined && metallicIndex !== -1) {
        this.unitUpdateResponse.metallicPaint![metallicIndex].on_unit = selected
          ? 'X'
          : '';
      }
    }
  }
  thereIsOptionsUpdateChange: boolean = false;
  onInteriorSelectionChange(rowElement: string | number, $event: Event) {
    this.thereIsOptionsUpdateChange = true;
    // Deselect all solidPaint and metallicPaint options
    if (this.unitUpdateResponse.clothInterior) {
      this.unitUpdateResponse.clothInterior.forEach((exterior) => {
        exterior.on_unit = '';
      });
    }
    if (this.unitUpdateResponse.leatherInterior) {
      this.unitUpdateResponse.leatherInterior.forEach((exterior) => {
        exterior.on_unit = '';
      });
    }
    const selected = ($event.target as HTMLInputElement).checked;
    const clothIndex = this.unitUpdateResponse.clothInterior?.findIndex(
      (interior) => interior.zoption === rowElement
    );
    if (clothIndex !== undefined && clothIndex !== -1) {
      this.unitUpdateResponse.clothInterior![clothIndex].on_unit = selected
        ? 'X'
        : '';
    } else {
      const leatherIndex = this.unitUpdateResponse.leatherInterior?.findIndex(
        (interior) => interior.zoption === rowElement
      );
      if (leatherIndex !== undefined && leatherIndex !== -1) {
        this.unitUpdateResponse.leatherInterior![leatherIndex].on_unit =
          selected ? 'X' : '';
      }
    }
  }

  onRimSelectionChange(rowElement: string | number, $event: Event) {
    this.thereIsOptionsUpdateChange = true;
    if (this.unitUpdateResponse.rim) {
      this.unitUpdateResponse.rim.forEach((exterior) => {
        exterior.on_unit = '';
      });
    }
    const selected = ($event.target as HTMLInputElement).checked;
    const rimIndex = this.unitUpdateResponse.rim?.findIndex(
      (rim) => rim.zoption === rowElement
    );
    if (rimIndex !== undefined && rimIndex !== -1) {
      this.unitUpdateResponse.rim![rimIndex].on_unit = selected ? 'X' : '';
    }
  }

  closePreviewModal() {
    this.previewOrderModalIsOpen = false;
  }
  selectedImageIndex: number = 0;
  thereIsUpdateChange: boolean = false;
  changeImage(number: number) {
    this.selectedImageIndex = number;
    this.cdr.detectChanges();
  }

  checkedPackages(rowElement: string | number, $event: Event) {
    this.thereIsOptionsUpdateChange = true;
    const checked = ($event.target as HTMLInputElement).checked;
    if (checked) {
      // Checkbox was checked
      const packIndex = this.unitUpdateResponse.packs.findIndex(
        (pack) => pack.code === rowElement
      );
      if (packIndex !== -1) {
        this.unitUpdateResponse.packs[packIndex].selected = checked ? 'X' : '';
      }
    } else {
      // Checkbox was unchecked
      const packIndex = this.unitUpdateResponse.packs.findIndex(
        (pack) => pack.code === rowElement
      );
      if (packIndex !== -1) {
        this.unitUpdateResponse.packs[packIndex].selected = checked ? 'X' : '';
      }
    }
  }

  onCheckedOptions(rowElement: string | number, $event: Event) {
    this.thereIsOptionsUpdateChange = true;
    const checked = ($event.target as HTMLInputElement).checked;
    if (checked) {
      // Checkbox was checked
      const optionIndex = this.unitUpdateResponse.modelOptions.findIndex(
        (option) => option.zoption === rowElement
      );
      if (optionIndex !== -1) {
        this.unitUpdateResponse.modelOptions[optionIndex].on_unit = checked
          ? 'X'
          : '';
      }
    } else {
      // Checkbox was unchecked
      const optionIndex = this.unitUpdateResponse.modelOptions.findIndex(
        (option) => option.zoption === rowElement
      );
      if (optionIndex !== -1) {
        this.unitUpdateResponse.modelOptions[optionIndex].on_unit = checked
          ? 'X'
          : '';
      }
    }
  }
  addToast(tone: 'critical' | 'positive' | 'neutral', teastText: string): void {
    this.toastService.pushToast({
      id: 'error-toast',
      tone: tone,
      toastText: teastText,
    } as DsToastModel);
  }
  selectedDespatchOption = '';
  getSelectedDespatchOption(
    $event: SelectListOption | SelectListOption[] | null
  ) {
    this.thereIsUpdateChange = true;
    const selectedValue = ($event as SelectListOption).id;
    this.selectedDespatchOption = selectedValue;
  }
  selectedSalesType = '';
  selectedSalesDispatch = '';
  zsdeliv = '';
  selectedSalesTypeChange(
    $event: SelectListOption | SelectListOption[] | null
  ) {
    this.thereIsUpdateChange = true;
    const selectedValue = ($event as SelectListOption).id;
    this.selectedSalesType = selectedValue;
  }
  selectedDelivery = '';
  selectedDeliveryChange($event: SelectListOption | SelectListOption[] | null) {
    this.thereIsUpdateChange = true;
    const selectedValue = ($event as SelectListOption).id;
    this.selectedDelivery = selectedValue;
  }
  z11UpdateUnitHeaderRequest: Z11UpdateUnitHeaderRequest = {
    euserid: '',
    body_number: '',
    vin: '',
    despatch_code: '',
    dealerPaymentCode: '',
    sale_type: '',
    payment_code: '',
    sdelivery: '',
  };

  doInvoice() {
    this.loadingAreaConfig = {
      id: 'bodyLoading',
      loadingTitle: 'Processing',
      loadingText: 'Processing Invoice',
    };
    this.loadingAreaService.addLoadingArea(this.loadingAreaConfig);
    this.z11UpdateUnitHeaderRequest.euserid =
      this.unitUpdateRequest.euserid || '';
    this.z11UpdateUnitHeaderRequest.body_number =
      this.unitUpdateResponse?.bodyno || '';
    this.z11UpdateUnitHeaderRequest.vin = this.unitUpdateResponse?.vin || '';
    this.z11UpdateUnitHeaderRequest.despatch_code = this.selectedDespatchOption
      ? this.selectedDespatchOption
      : this.unitUpdateResponse?.ord_mast?.zdes_cde || '00000';
    this.z11UpdateUnitHeaderRequest.dealerPaymentCode =
      this.unitUpdateResponse?.ord_mast?.pay_code || '';
    this.z11UpdateUnitHeaderRequest.sale_type = this.selectedSalesType
      ? this.selectedSalesType
      : this.unitUpdateResponse?.ord_mast?.zsale_typ || '';
    this.z11UpdateUnitHeaderRequest.payment_code =
      this.unitUpdateResponse?.ord_mast?.pay_code || '';
    this.z11UpdateUnitHeaderRequest.sdelivery = this.zsdeliv
      ? this.zsdeliv
      : this.unitUpdateResponse?.ord_mast?.zsdeliv || '00000';

    this.crossBorderService
      .unitUpdateHeader(this.z11UpdateUnitHeaderRequest)
      .subscribe(
        (response) => {
          this.addToast('positive', response?.message || '');
          this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
        },
        (error) => {
          console.error('Error updating unit header:', error);
          this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
        },
        () => {
          this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
          if(this.thereIsOptionsUpdateChange){
            this.SaveOrder();
          }
        }

      );
  }

  ivsrRequest: Z11CallIvsrRequest = {
    interior: '',
    exterior: '',
    euser: '',
    bodyno: '',
    zmodel: '',
    reqprodw: '',
    zdlr: '',
    quantity: '',
    template_id: '',
    order_template_broken: '',
    options: [
      {
        zoption: '',
        zoptind: '',
      },
    ],
  };

  z11CallIvsrResponse: Z11CallIvsrResponse = {
    alloc: '',
    error1: '',
    order: [],
    general_error_ws: '',
    oka_errors_ws: [] as OkaError[],
    reply_header_ws: {} as IvsrHeader,
  };

  SaveOrder() {
    this.loadingAreaConfig.id = 'saveOrder';
    this.loadingAreaConfig.loadingText = 'Processing...';
    this.loadingAreaService.addLoadingArea(this.loadingAreaConfig);

    this.ivsrRequest.euser = this.unitUpdateRequest.euserid || '';
    this.ivsrRequest.bodyno = this.unitUpdateResponse?.bodyno || '';
    this.ivsrRequest.zmodel = this.unitUpdateResponse?.ord_mast?.zmodel || '';
    this.ivsrRequest.template_id =
      this.unitUpdateResponse?.ord_mast?.template_id || '';
    this.ivsrRequest.zdlr = this.unitUpdateResponse?.ord_mast?.zdlr || '';
    if (this.ivsrRequest.template_id == '') {
      this.ivsrRequest.order_template_broken = 'X';
    } else {
      this.ivsrRequest.order_template_broken = '';
    }
    // this.ivsrRequest.order_template_broken = this.unitUpdateResponse?.ord_mast?.order_temp_broken || '';
    this.ivsrRequest.reqprodw =
      this.unitUpdateResponse?.ord_mast?.zreq_prodw || '';
    this.ivsrRequest.quantity = '1';
    //push options,push rims,packs all codes i regardless on option and for extrior add string of code and interior clouth leather
    //
    // this.ivsrRequest.options = this.unitUpdateResponse.modelOptions.
    // this.ivsrRequest.exterior = '';
    // this.ivsrRequest.interior = '';

    this.ivsrRequest.exterior =
      (this.unitUpdateResponse.solidPaint ?? [])
        .filter((paint) => paint.on_unit === 'X')
        .map((paint) => paint.zoption)
        .join('') ||
      (this.unitUpdateResponse.metallicPaint ?? [])
        .filter((paint) => paint.on_unit === 'X')
        .map((paint) => paint.zoption)
        .join('');
    this.ivsrRequest.interior =
      (this.unitUpdateResponse.clothInterior ?? [])
        .filter((interior) => interior.on_unit === 'X')
        .map((interior) => interior.zoption)
        .join('') ||
      (this.unitUpdateResponse.leatherInterior ?? [])
        .filter((interior) => interior.on_unit === 'X')
        .map((interior) => interior.zoption)
        .join('');

    this.ivsrRequest.options = [
      ...(this.unitUpdateResponse?.packs ?? [])
        .filter((pack) => pack.selected === 'X')
        .map((pack) => ({ zoption: pack.code, zoptind: 'S' })),
      ...(this.unitUpdateResponse?.rim ?? [])
        .filter((pack) => pack.on_unit === 'X')
        .map((pack) => ({ zoption: pack.zoption, zoptind: 'S' })),
      ...(this.unitUpdateResponse?.modelOptions ?? [])
        .filter((pack) => pack.on_unit === 'X')
        .map((pack) => ({ zoption: pack.zoption, zoptind: 'S' })),
      ...(this.unitUpdateResponse?.iopt ?? [])
        .filter((pack) => pack.std_ind === 'X')
        .map((pack) => ({ zoption: pack.zoption, zoptind: 'S' })),
      ...(this.unitUpdateResponse?.solidPaint ?? [])
        .filter((pack) => pack.on_unit === 'X')
        .map((pack) => ({ zoption: pack.zoption, zoptind: 'L' })),
      ...(this.unitUpdateResponse?.metallicPaint ?? [])
        .filter((pack) => pack.on_unit === 'X')
        .map((pack) => ({ zoption: pack.zoption, zoptind: 'L' })),
      ...(this.unitUpdateResponse?.clothInterior ?? [])
        .filter((pack) => pack.on_unit === 'X')
        .map((pack) => ({ zoption: pack.zoption, zoptind: 'P' })),
      ...(this.unitUpdateResponse?.leatherInterior ?? [])
        .filter((pack) => pack.on_unit === 'X')
        .map((pack) => ({ zoption: pack.zoption, zoptind: 'P' })),
    ];

    this.crossBorderService.callIvsr(this.ivsrRequest).subscribe(
      (response) => {
        this.z11CallIvsrResponse = response;
        this.orderResultModalIsOpen = true;
        if (response.general_error_ws !== '') {
          this.addToast(
            'critical',
            'Configuration errors - order was not saved.'
          );
        }

        this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
      },
      (error) => {
        console.error('Error calling IVSR:', error);
        this.addToast('critical', 'Error saving order.');
        this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
      }
    );
  }

  printIvoice() {
    this.loadingAreaConfig = {
      id: 'bodyLoading',
      loadingTitle: 'Loading',
      loadingText: 'Generating Invoice',
    };
    this.loadingAreaService.addLoadingArea(this.loadingAreaConfig);
    this.invoiceRequest.vin = this.unitUpdateResponse?.vin || '';
    this.invoiceRequest.iv_body_no = this.unitUpdateResponse?.bodyno || '';
    this.smsService.getInvoive(this.invoiceRequest).subscribe(
      (response) => {
        this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
        const base64String = response.ev_pdf_xstring;

        if (base64String) {
          const link = document.createElement('a');
          link.href = 'data:application/pdf;base64,' + base64String;
          link.download = 'invoice.pdf';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        } else {
          this.addToast('critical', 'Invoice URL not found.');
        }
      },
      (error) => {
        this.loadingAreaService.removeLoadingArea(this.loadingAreaConfig.id);
        console.error('Error fetching invoice:', error);
        this.addToast('critical', 'Error fetching invoice.');
      }
    );
  }

  protected buildOkaDetailLines(oe: OkaError): string[] {
    const ifFeatures = oe?.if_features ?? [];
    const thenFeatures = oe?.then_features ?? [];
    const thenGroupFeatures = oe?.then_group_features ?? [];
    const typeDescription =
      oe?.rule_type === 'Z'
        ? 'include'
        : oe?.rule_type === 'A'
          ? 'exclude'
          : '';

    const typeLabel = (t?: string) =>
      t === 'P' ? 'Interior' : t === 'L' ? 'Exterior' : 'Option';
    const flagLabel = (f?: string) => (f === '+' ? 'With' : 'Without');

    const lines: string[] = [];

    if (ifFeatures.length > 0) {
      if (
        ifFeatures.length === thenFeatures.length &&
        thenFeatures.length > 0
      ) {
        for (let j = 0; j < ifFeatures.length; j++) {
          const ifFeature = ifFeatures[j];
          const thenFeature = thenFeatures[j];
          const str = `${flagLabel(ifFeature.rule_boolean_flag)} ${typeLabel(
            ifFeature.type
          )} ${ifFeature.code} ${typeDescription} ${typeLabel(
            thenFeature.type
          )} ${thenFeature.code}`;
          lines.push(str);
        }
      } else if (ifFeatures.length === 1 && thenFeatures.length > 1) {
        const ifFeature = ifFeatures[0];
        const thenCodes = thenFeatures.map((t) => t.code).join(', ');
        const str = `${flagLabel(ifFeature.rule_boolean_flag)} ${typeLabel(
          ifFeature.type
        )} ${ifFeature.code} ${typeDescription}: ${thenCodes}`;
        lines.push(str);
      } else if (ifFeatures.length === 1 && thenGroupFeatures.length > 1) {
        const ifFeature = ifFeatures[0];
        const groupCodes = thenGroupFeatures
          .map((t) => `Group ${t.code}`)
          .join(', ');
        const str = `${flagLabel(ifFeature.rule_boolean_flag)} ${typeLabel(
          ifFeature.type
        )} ${ifFeature.code} ${typeDescription} ${
          ifFeature.rule_boolean_flag === '+' ? 'include' : 'exclude'
        }: ${groupCodes}`;
        lines.push(str);
      }
    }

    return lines;
  }
}
